import { useState, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

function DatePick({ 
  name, 
  label = 'Fecha', 
  value, 
  onChange, 
  size = 'medium', 
  allowHistoricalDates = false,
  allowFutureDates = true,
  returnType = 'date',
  width, // Nuevo prop opcional para ancho personalizado
  minWidth = 200, // Ancho mínimo por defecto
  maxWidth = 300 // Ancho máximo por defecto
}) {
  const [internalValue, setInternalValue] = useState(value ? dayjs(value) : null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    setInternalValue(value ? dayjs(value) : null);
  }, [value]);

  // Lógica para calcular el ancho
  const calculateWidth = () => {
    if (width) {
      // Si se proporciona width explícito, lo usamos respetando los límites
      return {
        width: `clamp(${minWidth}px, ${width}, ${maxWidth}px)`,
        minWidth: `${minWidth}px`,
        maxWidth: `${maxWidth}px`
      };
    }
    // Comportamiento por defecto (responsive)
    return {
      width: isMobile ? `${minWidth}px` : `${maxWidth}px`
    };
  };

  const handleChange = (newDate) => {
    setInternalValue(newDate);
    
    if (returnType === 'iso') {
      const isoDate = newDate ? newDate.toISOString() : null;
      onChange(name, isoDate);
    } else {
      onChange(newDate ? newDate.toDate() : null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={internalValue}
        onChange={handleChange}
        sx={{ 
          ...calculateWidth(), // Aplica el cálculo de ancho
          padding: "5px",
          '& .MuiInputBase-root': {
            height: size === 'small' ? '40px' : '56px' // Ajuste de altura según tamaño
          }
        }}
        slotProps={{
          textField: {
            variant: 'outlined',
            margin: 'dense',
            size: size === 'small' ? 'small' : 'medium',
          }
        }}
        format="DD/MM/YYYY"
        minDate={allowHistoricalDates ? null : dayjs().startOf('day')}
        maxDate={allowFutureDates ? null : dayjs().endOf('day')}
      />
    </LocalizationProvider>
  );
}

export default DatePick;